import { getHttpAuthHeader, http } from "./http";
import { SiteContent } from "../types/content";

export type ContentImageUploadResponse = {
  url: string;
  filename: string;
  size: number;
  mimetype: string;
};

export const ContentAPI = {
  async get() {
    const res = await http.get<SiteContent>("/content");
    return res.data;
  },
  async update(payload: Partial<SiteContent>) {
    const res = await http.put<SiteContent>("/admin/content", payload);
    return res.data;
  },
  async uploadImage(file: File) {
    const formData = new FormData();
    formData.append("image", file);
    const res = await http.post<ContentImageUploadResponse>(
      "/admin/content/upload-image",
      formData,
      { headers: { ...getHttpAuthHeader() } }
    );
    return res.data;
  },
};
